import { render, staticRenderFns } from "./PaymentElement.vue?vue&type=template&id=3ff23c2e&scoped=true&"
import script from "./PaymentElement.vue?vue&type=script&lang=js&"
export * from "./PaymentElement.vue?vue&type=script&lang=js&"
import style0 from "./PaymentElement.vue?vue&type=style&index=0&id=3ff23c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff23c2e",
  null
  
)

export default component.exports